export default {
  emailIcon: "/static/icons/icons_email_button.svg",
  emailShare: "mailto:?subject=[emailSubject]&body=[emailBody]",
  embedDimensions: "height=425,width=600",
  embedIcon: "/static/icons/icons_embed_btn.svg",
  newWindow: "new-window",
  printIcon: "/static/icons/icons_print_button.svg",
  printTitle: "Check out this article from Rivals.com",
  rivals: " – Rivals.com"
};
